import React, { useEffect, useMemo, useState } from 'react';

import { ACTION_ERROR_INTER, MODULE_NAME } from './constant';
import { Component } from './component';
import { action } from './action';
import { convert } from './convert';
import { usePaginatedData } from '../../lib/util/usePagintationData';

export const Container: React.FC = () => {
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);

  const pageSize = 10;

  const onSuccess = (data: any) => {
    const totalPage = data?.pages[0].total;

    if (totalPage) {
      setPageCount(totalPage);
    }
  };

  const {
    data: preFetch,
    isLoading,
    isError,
    isSuccess,
    error,
  } = usePaginatedData(
    action,
    MODULE_NAME,
    {
      pageParam: page,
      pageSize,
    },
    onSuccess,
  );

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const withdrawList = useMemo(() => {
    const list = preFetch?.pages[0].list as unknown as any;

    if (list) {
      const convertedList = convert(list);

      return { ...convertedList };
    }
  }, [preFetch]);

  const getErrorMessage = () => {
    const errorObj: ACTION_ERROR_INTER = error as ACTION_ERROR_INTER;

    if (error) {
      return errorObj.message;
    }
  };

  return (
    <Component
      data={withdrawList}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      errorMessage={getErrorMessage()}
      pageSize={pageSize}
      page={page}
      onChangePage={handlePageChange}
      pageCount={pageCount}
    />
  );
};
